export function debounce(func, waitMillis) {
  let timeout = null;
  const cancel = () => {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  const debounced = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    const later = () => {
      timeout = null;
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, waitMillis);
  };
  debounced.cancel = cancel;
  return debounced;
}
//# sourceMappingURL=debounce.js.map